import * as React from 'react';

export default function KapschLogo(props) {
  return (
    <svg
      id="prefix__Ebene_1"
      xmlns="http://www.w3.org/2000/svg"
      x={0}
      y={0}
      height="60"
      viewBox="0 0 312.2 67.7"
      xmlSpace="preserve"
      {...props}
    >
      <style>{'.prefix__st0{fill:#FFB300}'}</style>
      <path
        className="prefix__st0"
        d="M44.7,36.4c-1.5,1.3-2.7,2.3-2.7,4.2c0,1.2,0.6,2.1,1.6,3.3l7.5,9.2c6-5.4,9.8-13.3,9.8-22
                c0-2.8-0.4-5.6-1.2-8.2L44.7,36.4z" /><path className="prefix__st0"  d="M31.7,45.6c-1-1.4-1.5-2.7-1.5-4.1c0-2.7,0.8-5.9,3.3-8.2l21.8-19.5C49.9,6.3,41.1,1.4,31.2,1.4
                C14.7,1.4,1.4,14.7,1.4,31.2c0,9.4,4.4,17.8,11.2,23.3l8.2-38.4h12.3L23.7,60c2.4,0.6,4.9,0.9,7.4,0.9c3.7,0,7.3-0.7,10.6-2
                L31.7,45.6z" />
      </svg>
  );
}
